import { render, staticRenderFns } from "./FormMessageTicket.vue?vue&type=template&id=7b2d0fb6"
import script from "./FormMessageTicket.vue?vue&type=script&lang=js"
export * from "./FormMessageTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports